import React from "react";


interface IToggleSwitch {
    checked?: boolean;
    id?: string;
    disabled?: boolean;
    onToggleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    size?: string;
}

const ToggleSwitch: React.FC<IToggleSwitch> = ({
    checked,
    id,
    disabled,
    onToggleChange,
    size,
}) => {
    return (
        <>
            <div
                className="form-check form-switch"
                style={{ fontSize: `${size}` }}
            >
                <input
                    type="checkbox"
                    id={id}
                    data-id=""
                    checked={checked}
                    className="form-check-input"
                    disabled={disabled}
                    onChange={onToggleChange}
                />
            </div>
        </>
    );
};

export default ToggleSwitch;